<script setup>
import {computed, watch, onBeforeUnmount} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import ThemesEditorSidebar from './ThemesEditorSidebar'
import ThemesEditorTabs from './ThemesEditorTabs'
import ThemesEditorCodemirror from './ThemesEditorCodemirror'
import {useThemesStore} from '@/stores/themes'
import {useModalsStore} from '@/stores/modals'
import {useAppStore} from '@/stores/appStore'

const route = useRoute()
const router = useRouter()

const appStore = useAppStore()
const themesStore = useThemesStore()
const modalsStore = useModalsStore()

const activeEditorKey = computed(() => themesStore.activeEditorKey)
const editors = computed(() => themesStore.editors)
const codeMirror = computed(() => themesStore.codeMirror)

const findKeyboardShortcut = (e) => {
    if (
        e.metaKey
        && e.shiftKey
        && e.keyCode === 70
    ) {
        e.preventDefault()

        if (codeMirror.value) {
            let str = codeMirror.value.getSelection()
            if (str) {
                if (themesStore.searchStr !== str) {
                    themesStore.findModalItemIndex = 0
                }
                themesStore.searchStr = str
            }
        }

        modalsStore.show({
            componentName: 'ThemesFindModal'
        })
    }
}

window.addEventListener('keydown', findKeyboardShortcut)

if (!route.query.section && editors.value.length) {
    const editor = editors.value[activeEditorKey.value]
    router.push({query: {section: editor.sectionName, id: editor.id}})
}

themesStore.init()
themesStore.setSectionName(route.query.section || 'page_templates')
appStore.navigationComponent = 'themes_editor'

onBeforeUnmount(() => {
    window.removeEventListener('keydown', findKeyboardShortcut)
})

watch(
    () => [route.query.section, route.query.id],
    ([section, id]) => {
        if (section && id) {
            themesStore.createEditor({
                sectionName: section,
                id: id,
            })
        }
    },
    {immediate: true}
)
</script>

<template>
    <div class="d-flex h-100">
        <aside class="w-25 overflow-hidden">
            <ThemesEditorSidebar/>
        </aside>

        <main class="flex-fill w-100 overflow-hidden">
            <div class="d-flex flex-column h-100">
                <div class="themes-editor-toolbar overflow-x-scroll" data-themes-editor-toolbar>
                    <ThemesEditorTabs/>
                </div>

                <template v-for="(editor, index) in editors" :key="editor.key">
                    <div v-if="index === activeEditorKey" class="themes-editor--editor-container">
                        <ThemesEditorCodemirror :editor="editor" :focused="editor.focused"
                                                :latest-code="editor.latestCode" class="d-flex flex-column h-100"/>
                    </div>
                </template>
            </div>
        </main>
    </div>
</template>

<style scoped>
.themes-editor--editor-container {
    height: calc(100% - 38px);
}

.themes-editor-toolbar::-webkit-scrollbar {
    display: none;
}
</style>